export * from "./featured-offer-brand.component";
